import http from '../http';
import Qs from 'qs';

// （PC端）课程类型添加
const addCourseType = (params) =>
  http
    .post('/theUserIdentity/courseTypeDefine/addCourseTypeDefine', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// （PC端）课程类型删除

const deleteCourseType = (params) =>
  http
    .post(
      `/theUserIdentity/courseTypeDefine/deleteCourseTypeDefine`,
      Qs.stringify(params),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data);

// （PC端）课程类型修改
const editCourseType = (params) =>
  http
    .post('/theUserIdentity/courseTypeDefine/updateCourseTypeDefine', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// （PC端）课程类型列表分页
const getCourseTypeList = (params) =>
  http
    .get('/theUserIdentity/courseTypeDefine/courseTypeDefinePage', { params })
    .then((res) => res.data);

// （PC端）课程类型列表分页
const getOtherSetting = (params) =>
  http
    .get('/sysStaticDatas/getOtherSetting', { params })
    .then((res) => res.data);

// （PC端）课程类型列表分页 - 新的 2022-05-06
const getOtherSettingNew = (params) =>
  http
    .get('/theUserIdentity/sysStaticDatas/getOtherSetting', { params })
    .then((res) => res.data);

const getCourseTypeTapList = (params) =>
  http
    .get('/theUserIdentity/courseTypeDefine/getCourseTypeTapList', { params })
    .then((res) => res.data);

const getTapList = (params) =>
  http
    .get('/theUserIdentity/courseTypeDefine/getTapList', { params })
    .then((res) => res.data);

// 新增静态参数配置
const saveSysStaticData = (params) =>
  http
    .post('/sysStaticDatas/saveSysStaticData', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 新增静态参数配置 - 新的 2022-05-06
const saveSysStaticDataNew = (params) =>
  http
    .post('/theUserIdentity/sysStaticDatas/saveSysStaticData', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 新增课程
const addcourse = (params) =>
  http({
    method: 'post',
    url: '/theUserIdentity/courseClass',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);
// 修改课程
const editCourse = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/courseClass/update`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 根据id获取课程商品详情
const getCourseClassDtl = (params) =>
  http
    .get('/theUserIdentity/courseClass/getCourseClassDtl', { params })
    .then((res) => res.data);

// 课程资源详情
const getCourseDetail = (params) =>
  http
    .get('/theUserIdentity/courseDefine/getCourseDetail', { params })
    .then((res) => res.data);

// 查询该学校的课程分类是否有教育局分类-学校端
const getSchoolTypeStatusApi = (params) =>
  http
    .get('/theUserIdentity/courseTypeDefine/serachIsExsitEduCourseTypeDefine', {
      params
    })
    .then((res) => res.data);

// 查询教师
const serachTeachers = (params) =>
  http
    .get('/theUserIdentity/dataSearch/searchTeachers', { params })
    .then((res) => res.data);

// 学校端-课程分类查询（提供方&教育局）
const courseTypeListByOffer = (params) =>
  http
    .get('/school/courseTypeDefine/courseTypeListByOffer', { params })
    .then((res) => res.data);

// 查找商品的分账规则列表
const getListByTypeAndOrgIdAndSchId = (params) =>
  http
    .get('/theUserIdentity/divideConfigMainItems/listByTypeAndOrgIdAndSchId', {
      params
    })
    .then((res) => res.data);

// 查找商品的分账规则列表(有已下单的商品)
const getListByCondition = (params) =>
  http
    .get('/theUserIdentity/divideConfigMainItems/listByCondition', { params })
    .then((res) => res.data);

// 参与平台发放教师工资
const postPayWagesApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysStaticDatas/switchPayWages`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 教师补签设置
const postTeaSignDayScopeApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysStaticDatas/setTeaSignDayScope`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 是否开启教师位置打卡
const postSignPlaceApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysStaticDatas/switchSignPlace`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 添加考勤地点（运营端/学校端）
const addSysSignPointApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysSignPoint/add`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 查询考勤地点列表（运营端/学校端/教育局端）
const getSysSignPointListApi = (params) =>
  http
    .get('/theUserIdentity/sysSignPoint/list', { params })
    .then((res) => res.data);

// 删除考勤地点（运营端/学校端）
const delSysSignPointApi = (params) =>
  http
    .get('/theUserIdentity/sysSignPoint/delete', { params })
    .then((res) => res.data);

// 修改考勤范围（运营端/学校端）
const updateSysSignPointApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysSignPoint/update`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 查询服务签约协议模板配置-分页
const getServiceSigningAgreementPageApi = (params) =>
  http
    .get('/theUserIdentity/template/serviceSigningAgreementPage', { params })
    .then((res) => res.data);

// 保存服务签约协议
const addServiceSigningAgreementApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/template/addTemplate`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 查询服务签约协议模板配置-分页
const getServiceSigningAgreementApi = (params) =>
  http
    .get('/theUserIdentity/template/serviceSigningAgreementDetail', { params })
    .then((res) => res.data);

// 更新服务签约协议
const updateServiceSigningAgreementApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/template/updateTemplate`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 查询电子收据模板配置-分页
const getElectronicReceiptPageApi = (params) =>
  http
    .get('/theUserIdentity/electronicReceipt/page', { params })
    .then((res) => res.data);

// 查询服务签约协议-详情
const getElectronicReceiptDetailApi = (params) =>
  http
    .get('/theUserIdentity/electronicReceipt/electronicReceiptTemplateDetail', {
      params
    })
    .then((res) => res.data);

// 保存电子收据模板
const addTemplateApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/electronicReceipt/addElectronicReceiptTemplate`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 编辑电子收据模板
const updateTemplateApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/electronicReceipt/updateElectronicReceiptTemplate`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 运营端-获取服务协议默认模板
const serviceSigningAgreementDefaultTemplateApi = (params) =>
  http
    .get('/theUserIdentity/template/serviceSigningAgreementDefaultTemplate', {
      params
    })
    .then((res) => res.data);

// 运营端-获取电子收据模板
const electronicReceiptDefaultTemplateApi = (params) =>
  http
    .get('/theUserIdentity/template/electronicReceiptDefaultTemplate', {
      params
    })
    .then((res) => res.data);

// 运营端-批量设置服务签约协议模板
const batchSaveOpUpdateTemplateApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/template/batchSaveOpUpdateTemplate`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 获取服务协议pdf预览文件token
const getPreviewServicePdfApi = (params) =>
  http.get('/file/previewServicePdf/token', { params }).then((res) => res.data);

// 运营端-学生考勤状态通知设置
const studentSignStatusNotificationApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysStaticDatas/studentSignStatusNotification`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 运营端-设置家长请假时间限制
const setParentLeaveTimeLimitApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysStaticDatas/setParentLeaveTimeLimit`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 运营端-家长端发起请假是否开启自动审批
const setAutoCheckLeavePassApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysStaticDatas/autoCheckLeavePass`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 设置学校退款审批配置
const saveApproveRefundConfigApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysStaticDatas/saveApproveRefundConfig`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 批量设置学校退款审批配置
const batchSaveApproveRefundConfigApi = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysStaticDatas/BatchSaveApproveRefundConfig`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 根据学校Id获取退款审批配置

const getApproveRefundDtoBySchoolIdApi = (params) =>
  http
    .get('/theUserIdentity/sysStaticDatas/getApproveRefundDtoBySchoolId', {
      params
    })
    .then((res) => res.data);

export default {
  addCourseType,
  deleteCourseType,
  editCourseType,
  getCourseTypeList,
  getOtherSetting,
  getOtherSettingNew,
  getCourseTypeTapList,
  getTapList,
  saveSysStaticData,
  saveSysStaticDataNew,
  addcourse,
  editCourse,
  getCourseClassDtl,
  getCourseDetail,
  getSchoolTypeStatusApi,
  serachTeachers,
  courseTypeListByOffer,
  getListByTypeAndOrgIdAndSchId,
  getListByCondition,
  postPayWagesApi,
  postTeaSignDayScopeApi,
  postSignPlaceApi,
  addSysSignPointApi,
  getSysSignPointListApi,
  delSysSignPointApi,
  updateSysSignPointApi,
  getServiceSigningAgreementPageApi,
  addServiceSigningAgreementApi,
  getServiceSigningAgreementApi,
  updateServiceSigningAgreementApi,
  getElectronicReceiptPageApi,
  addTemplateApi,
  updateTemplateApi,
  getElectronicReceiptDetailApi,
  serviceSigningAgreementDefaultTemplateApi,
  batchSaveOpUpdateTemplateApi,
  electronicReceiptDefaultTemplateApi,
  getPreviewServicePdfApi,
  studentSignStatusNotificationApi,
  setParentLeaveTimeLimitApi,
  setAutoCheckLeavePassApi,
  saveApproveRefundConfigApi,
  batchSaveApproveRefundConfigApi,
  getApproveRefundDtoBySchoolIdApi
};
